import Vue from 'vue';
import VueResource from 'vue-resource';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import formatarData from '~js/formatar-data';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

function normalizarParaVisualizar(acesso) {
  if (acesso.turma) {
    acesso.turma.dataInicioInscTurma = formatarData.paraData(acesso.turma.dataInicioInscTurma);
    acesso.turma.dataLimiteInscTurma = formatarData.paraData(acesso.turma.dataLimiteInscTurma);
    acesso.turma.dataInicioTurma = formatarData.paraData(acesso.turma.dataInicioTurma);
    acesso.turma.dataFimTurma = formatarData.paraData(acesso.turma.dataFimTurma);

    if (acesso.turma.faixaValores) {
      acesso.turma.faixaValores.sort(function (a, b) {
        return a.descricao < b.descricao ? -1 : a.descricao > b.descricao ? 1 : 0;
      });
    }
  }

  return acesso;
}

async function normalizarParaSalvar(inscricao) {
  if (inscricao.dataNascimento) {
    inscricao.dataNascimento = await formatarData.paraNumero(inscricao.dataNascimento);
  }

  return inscricao;
}

export default {
  adicionar: async (inscricao) => {
    inscricao = await normalizarParaSalvar(inscricao);

    inscricao = await converterObjetoFormData(inscricao);

    return Vue.http.post('/api/acessos/inscricao', inscricao).then(res => res.data);
  },
  alterar: async (inscricao, id) => {
    inscricao = await normalizarParaSalvar(inscricao);

    inscricao = await converterObjetoFormData(inscricao);

    return Vue.http.put(`/api/acessos/${id}/inscricao`, inscricao).then(res => res.data);
  },
  arquivos: async (id, utilizaArquivos) => {
    if (!utilizaArquivos || !id)
      return [];

    return Vue.http.get(`/api/acessos/${id}/inscricao/arquivos`)
      .then(response => response.data);
  },
  download: async (id, arquivo) => {
    return Vue.http.get(`/api/acessos/${id}/inscricao/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
  listaAcessoItens: (filtros, tipo) => {
    const parametros = Object.assign({}, filtros);

    switch (tipo) {
      case 'acessos.cursos':
        return Vue.http.get('/api/acessos/cursos', { params: parametros });
      case 'acessos.eventos':
        return Vue.http.get('/api/acessos/eventos', { params: parametros });
      case 'acessos.doacoes':
        return Vue.http.get('/api/acessos/doacoes', { params: parametros });
      case 'acessos.licitacoes':
        return Vue.http.get('/api/acessos/licitacoes', { params: parametros });
      default:
        return Vue.http.get('/api/acessos/cursos', { params: parametros });
    }
  },
  listaImportacao: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    return Vue.http.get('/api/acessos/importacao', { params: parametros }).then(response => response.data);
  },
  listaImportacaoExcel: filtros => {
    return Vue.http.get('/api/acessos/importacao/excel', { params: filtros, responseType: 'blob' })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
  obterPorId: id => {
    return Vue.http.get(`/api/acessos/${id}`)
      .then(response => response.data)
      .then(acesso => normalizarParaVisualizar(acesso));
  },
  busca: (documento, id, estrangeiro, idInscricaoDiretaCript) => {
    return Vue.http.get('/api/acessos/busca', {
      params: {
        'documento' : documento,
        'id': id,
        'estrangeiro': estrangeiro,
        'idInscricaoDiretaCript': idInscricaoDiretaCript
      }
    })
      .then(resposta => resposta.body);
  },
  boleto: (id) => {
    return Vue.http.get('/api/acessos/boleto', {
      params: {
        'id': id
      }
    }).then(resposta => resposta.body);
  },
  cep: cepTexto => {
    cepTexto = cepTexto.replace("-", "").replace(".", "");

    return Vue.http.get(`/api/acessos/cep/${cepTexto}`)
      .then(response => response.data);
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/acessos/servico.js